/**
 * @file: 满意度调查 表单 抽屉
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/8/7      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import {Spin,Drawer, Empty } from 'antd';
import PropTypes from "prop-types";
import {isEmpty,trim} from '@utils/utils';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@/components/Lang/Lang";
import SurveyTaskFrom from "./SurveyTaskFrom"
import DopIndexAction from "../../pages/Index/dopIndex.action"
import "./surveyTaskFrom.less";

export default class SurveyTaskFromShow extends PureComponent {
    static propTypes = {
        buyerSurveyTaskId: PropTypes.string.isRequired,
        item: PropTypes.object,// name telCode mobile abbreviate buyerCode
    };
    static defaultProps = {
        buyerSurveyTaskId: "", // 显示
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        this.setState({
            visibleDrawer: flag,
        });
        if(flag){
            this.getSurveyList()
        }else {
            this.setState({
                questionList:[]
            })
        }
    }
    /*
     * 客户已调研完成问卷列表(问卷下拉)
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8334
     */
    getSurveyList() {
        this.loading(true);
        const {buyerId} = this.props;
        DopIndexAction.postHttpAction("/service/mg/buyer/survey/buyer-survey-list",{
            id:buyerId,
        }).then(res=>this.getSurveyListRes(res.data)).catch(err=>this.getSurveyListRes(err));
    }
    getSurveyListRes(res){
        const {success,valid,models=[],} = res;
        if (success && valid) {
            this.setState({
                surveyList:models
            })
            if(models&&models.length>0){
                this.getSurveyDetail(models[0].buyerSurveyTaskId)
            }else this.loading(false);
        }else this.loading(false);
    }
    /*
     * 客户调研问卷答案
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8335
     */
    getSurveyDetail(id,callBack){
        if(!isEmpty(id)){
            this.loading(true);
            DopIndexAction.postHttpAction("/service/mg/buyer/survey/buyer-survey-answer",{
                id:id,
            }).then(res=>this.getSurveyDetailRes(res.data,id,callBack)).catch(err=>this.getSurveyDetailRes(err));
        }
    }
    getSurveyDetailRes(res,buyerSurveyTaskId,callBack){
        const {success,valid,models=[],} = res;
        if (success && valid) {
            this.setState({
                questionList:models,
                buyerSurveyTaskId:buyerSurveyTaskId
            })
            if(typeof callBack=='function'){
                callBack();
            }
        }else {
            this.setState({
                questionList:[]
            })
        }
        this.loading(false);
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    handleChangeSurvey(value,callBack){
        this.getSurveyDetail(value,callBack);
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
        if(this.showTimer)clearTimeout(this.showTimer)
    };
    render() {
        const { item={},children,className=""} = this.props;
        const { visibleDrawer=false,loading = true, surveyList=[], questionList=[], buyerSurveyTaskId} = this.state;
        return (<Fragment>
            {children?<span className={className} onClick={()=>this.showDrawer(true)}>{children}</span>:<AuthBtn icon={"ri-draft-line"} tips = {Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}
                     onClick={()=>this.showDrawer(true)}
                     className={"blueIconTips"}  />}
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                <span className={"font_18 fw_500"}>{Lang({id:"ManYiDuDiaoCha",default:"满意度调查"})}</span>
            </div>}
                    width={1100}
                    rootClassName={"surveyTaskFromrWrap"}
                    maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visibleDrawer}>
                <Spin spinning={loading}>
                    <div className={"mainWrap black89 font_14"}>
                        <SurveyTaskFrom surveyList={surveyList}
                                        questionList={questionList}
                                        handleChangeSurvey={(v,callBack)=>this.handleChangeSurvey(v,callBack)}
                                        buyerSurveyTaskId={buyerSurveyTaskId}
                                        disabled={true}
                                        item={item} />
                        {!loading&&(!surveyList||surveyList.length==0)&&<div className={"mt_24"}>
                            <Empty mage={Empty.PRESENTED_IMAGE_SIMPLE} description={<div className={"black66"}>{Lang({id: 'ZanWuShuJu',default:'暂无数据'})}</div>} />
                        </div>}
                    </div>
                </Spin>
            </Drawer>
        </Fragment>);
    }
}